import React from 'react'

import {
  Col,
  Row,
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled
} from 'components'
import { GrupoIten } from 'services/NGT/ReportsEffectives'
import { COLORS } from 'utils'
import FormatarNumeros from 'utils/formatNumbers'
interface ITableReportsSupplier {
  tableData: GrupoIten[]
}
const TableReportsSupplier: React.FC<ITableReportsSupplier> = ({
  tableData
}) => {
  const index = tableData.map((data) => data.grupo).indexOf('SubTotal')
  return (
    <TableContainerStyled>
      <TableStyled>
        <TableHeadStyled>
          <TableRowStyled>
            <TableCellStyled>Contrato</TableCellStyled>
            <TableCellStyled>Mês / Ano</TableCellStyled>
            <TableCellStyled align="center">
              Status Movimentação
            </TableCellStyled>
            <TableCellStyled align="center">DE</TableCellStyled>
            <TableCellStyled align="center">DIR</TableCellStyled>
            <TableCellStyled align="center">GG</TableCellStyled>
            <TableCellStyled align="center">GER</TableCellStyled>
            <TableCellStyled align="center">Ativo</TableCellStyled>
            <TableCellStyled align="center">Demitido</TableCellStyled>
            <TableCellStyled align="center">Acesso</TableCellStyled>
            <TableCellStyled align="center">Transferido</TableCellStyled>
            <TableCellStyled align="center">Afastado</TableCellStyled>
            <TableCellStyled align="center">Compartilhado</TableCellStyled>
            <TableCellStyled align="center">
              <Col>
                Total Efetivo
                <Row justifyContent="center" alignItems="center">
                  <TableCellStyled align="center">
                    Com demitido
                  </TableCellStyled>
                  <TableCellStyled align="center">|</TableCellStyled>
                  <TableCellStyled align="center">
                    Sem Demitidos
                  </TableCellStyled>
                </Row>
              </Col>
            </TableCellStyled>
            <TableCellStyled align="center">Contraparte</TableCellStyled>
          </TableRowStyled>
        </TableHeadStyled>
        <TableBodyStyled>
          {tableData?.map(
            (row) =>
              !row.grupo && (
                <TableRowStyled>
                  <TableCellStyled>{row.cdContrato}</TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.competencia}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row.flStatusMobilizacao}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.diretoriaExecutiva}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.diretoria}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.gerenciaGeral}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.gerencia}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtAtivo)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtDemitido)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtAcesso)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtTransferido)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtAfastado)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {formatarNumero(row.qtCompartilhado)}
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    <Row justifyContent="center" alignItems="center">
                      <TableCellStyled align="center">
                        {formatarNumero(row?.qtTotalEfetivoComDemitido)}
                      </TableCellStyled>
                      <TableCellStyled align="center">
                        {formatarNumero(row?.qtTotalEfetivoSemDemitido)}
                      </TableCellStyled>
                    </Row>
                  </TableCellStyled>
                  <TableCellStyled align="center">
                    {row?.nmContraparte}
                  </TableCellStyled>
                </TableRowStyled>
              )
          )}
          <TableRowStyled style={{ background: COLORS.lightGray }}>
            <TableCellStyled>Total</TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled></TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtAtivo)}
            </TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtDemitido)}
            </TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtAcesso)}
            </TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtTransferido)}
            </TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtAfastado)}
            </TableCellStyled>
            <TableCellStyled align="center">
              {formatarNumero(tableData[index].qtCompartilhado)}
            </TableCellStyled>
            <TableCellStyled align="center">
              <Row justifyContent="center" alignItems="center">
                <TableCellStyled align="center">
                  {formatarNumero(tableData[index].qtTotalEfetivoSemDemitido)}
                </TableCellStyled>
                <TableCellStyled align="center">
                  {formatarNumero(tableData[index].qtTotalEfetivoComDemitido)}
                </TableCellStyled>
              </Row>
            </TableCellStyled>
            <TableCellStyled></TableCellStyled>
          </TableRowStyled>
        </TableBodyStyled>
      </TableStyled>
    </TableContainerStyled>
  )
}

function formatarNumero(numero: number) {
  return FormatarNumeros.formatarNumero(numero) as unknown as number;
}

export default TableReportsSupplier
